<div class="flex flex-col gap-4 frame pb-5 my-2">
  <div class="flex gap-4 items-center bg-surface-50 dark:bg-surface-800 rounded-t-lg p-5">
    <p-button
      type="button"
      [label]="singular ? ('common.text_groups.add_entity' | translate: { entity: singular | translate }) : ('common.text_groups.add' | translate)"
      (onClick)="add()"
      [disabled]="disabled">
      <i class="pi pi-plus"></i>
    </p-button>
    <p-button
      type="button"
      [label]="'common.text_groups.remove_all' | translate"
      (onClick)="clearAll()"
      severity="secondary"
      disabled="{{ value.length === 0 }}"
      [disabled]="disabled">
      <i class="pi pi-trash"></i>
    </p-button>
  </div>

  <div class="flex flex-col gap-0.5">
    <div *ngFor="let item of value; let i = index; trackBy: trackByFn">
      <div class="flex flex-row items-center gap-5 p-5">
        <label [for]="`${singular}-${repeatChar(i)}`" class="text-md font-bold min-w-fit">{{ i + 1 }}.</label>
        <div class="flex flex-col gap-2 w-full">
          <input
            [id]="`${singular}-${repeatChar(i)}`"
            pInputText
            fluid
            [ngModel]="value[i]"
            [disabled]="disabled ? true : false"
            (ngModelChange)="update(i, $event)"
            [class.ng-invalid]="error[i]"
            [class.ng-dirty]="error[i]" />
          <p class="text-xs text-red-500 font-bold text-right" *ngIf="error?.[i] || ''">{{ error[i] }}</p>
        </div>
        <button type="button" (click)="remove(i)" [disabled]="disabled">
          <i [ngClass]="['pi pi-eraser', disabled ? 'text-gray-200' : 'hover:text-red-500']"></i>
        </button>
      </div>
    </div>
  </div>
</div>
